<div class="cf-dlg iaf">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon"><mat-icon>{{ kind.icon }}</mat-icon></div>
    <div class="iaf-header-text">
      <h2 class="cf-dlg-title">{{ title }}</h2>
      <p class="cf-dlg-subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" [message]="isEdit ? 'Cargando inversión…' : 'Preparando formulario…'"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="isEdit ? 'Guardando inversión…' : 'Creando inversión…'"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="iaf-alert iaf-alert--error">
        <mat-icon>error</mat-icon>
        <span>{{ isEdit ? 'No se pudo cargar la inversión.' : 'No se pudieron cargar los datos del formulario.' }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body iaf-body" [formGroup]="form">
      <div class="iaf-layout">
        <div class="iaf-main">
          <section class="iaf-section">
            <span class="cf-dlg-section__label">Datos de la inversión</span>

            <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.account">
              <app-autocomplete [control]="accountControl" [config]="accountConfig"></app-autocomplete>
              <div class="cf-field__error" *ngIf="submitted && errors.account"><mat-icon>error</mat-icon> {{ errors.account }}</div>
              <div class="iaf-hint" *ngIf="!accounts.length">No tienes cuentas contables de {{ kind.singular }} ({{ kind.type === 2 ? '21x' : '20x' }}).</div>
            </div>

            <app-textarea [control]="elementDescriptionControl"
              [config]="{ label: 'Descripción del elemento', placeholder: 'Vehículo, maquinaria, aplicación informática…', rows: 2 }">
            </app-textarea>

            <div class="iaf-provider">
              <div class="cf-field--required iaf-provider__field" [class.cf-field--invalid]="submitted && errors.provider">
                <app-autocomplete [control]="providerControl" [config]="providerConfig"></app-autocomplete>
                <div class="cf-field__error" *ngIf="submitted && errors.provider"><mat-icon>error</mat-icon> {{ errors.provider }}</div>
              </div>
              <button mat-stroked-button type="button" class="cf-btn iaf-provider__btn" (click)="newContact()" [disabled]="loadingContacts">
                <mat-icon>person_add</mat-icon> Nuevo contacto
              </button>
            </div>

            <div class="cf-dlg-row">
              <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.dateBuy">
                <app-date [control]="dateBuyControl" [config]="{ label: 'Fecha de compra', required: true }"></app-date>
                <div class="cf-field__error" *ngIf="submitted && errors.dateBuy"><mat-icon>error</mat-icon> {{ errors.dateBuy }}</div>
              </div>

              <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.dateStartWorking">
                <app-date [control]="dateStartWorkingControl" [config]="{ label: 'Puesta en funcionamiento', required: true }"></app-date>
                <div class="cf-field__error" *ngIf="submitted && errors.dateStartWorking"><mat-icon>error</mat-icon> {{ errors.dateStartWorking }}</div>
              </div>
            </div>
          </section>

          <section class="iaf-section">
            <span class="cf-dlg-section__label">
              Amortización
              <span class="iaf-label-hint" *ngIf="loadingCoefficient">Consultando tabla oficial…</span>
            </span>

            <div class="iaf-grid">
              <app-field [control]="amortizationTypeControl" [config]="{ label: 'Tipo de amortización', readonly: true }"></app-field>

              <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.maximumLinealCoeficient">
                <app-field [control]="maximumLinealCoeficientControl" [config]="{ label: 'Coeficiente lineal máximo', type: 'number', required: true, suffix: '%', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="submitted && errors.maximumLinealCoeficient"><mat-icon>error</mat-icon> {{ errors.maximumLinealCoeficient }}</div>
              </div>

              <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.maximumPeriod">
                <app-field [control]="maximumPeriodControl" [config]="{ label: 'Periodo máximo', type: 'number', required: true, suffix: 'años', min: 0, step: 1, inputmode: 'numeric' }"></app-field>
                <div class="cf-field__error" *ngIf="submitted && errors.maximumPeriod"><mat-icon>error</mat-icon> {{ errors.maximumPeriod }}</div>
              </div>
            </div>

            <div class="iaf-hint iaf-hint--warning" *ngIf="coefficientNotFound">
              La cuenta no está en la tabla oficial de amortización: indica el coeficiente y el periodo a mano.
            </div>
          </section>

          <section class="iaf-section">
            <span class="cf-dlg-section__label">Importes e impuestos</span>

            <div class="iaf-grid iaf-grid--2">
              <div class="cf-field--required" [class.cf-field--invalid]="submitted && errors.totalWithoutTax">
                <app-field [control]="totalWithoutTaxControl" [config]="{ label: 'Total sin impuestos', type: 'number', required: true, suffix: '€', min: 0, step: 0.01, inputmode: 'decimal' }"></app-field>
                <div class="cf-field__error" *ngIf="submitted && errors.totalWithoutTax"><mat-icon>error</mat-icon> {{ errors.totalWithoutTax }}</div>
              </div>

              <app-multi-select-autocomplete [control]="taxesControl" [config]="taxesConfig"></app-multi-select-autocomplete>
            </div>

            <div class="iaf-totals">
              <div class="iaf-total">
                <span class="iaf-total__label">Impuestos</span>
                <span class="iaf-total__value">{{ totalTax | number:'1.2-2' }} €</span>
              </div>
              <div class="iaf-total iaf-total--accent">
                <span class="iaf-total__label">Total</span>
                <span class="iaf-total__value">{{ total | number:'1.2-2' }} €</span>
              </div>
            </div>
          </section>

          <section class="iaf-section" *ngIf="isProjectEnable">
            <span class="cf-dlg-section__label">Asociaciones/Fundaciones</span>
            <app-autocomplete [control]="form.get('project')" [config]="{
                label: 'Proyecto',
                placeholder: 'Seleccionar proyecto...',
                options: projects
              }">
            </app-autocomplete>
            <ng-container *ngIf="isNonprofit">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Partida</mat-label>
                <mat-select formControlName="clasificadorPartida" (selectionChange)="onPartidaChange()">
                  <mat-option [value]="null">Sin partida</mat-option>
                  <mat-option *ngFor="let partida of clasificadorCatalog" [value]="partida.nombre">{{ partida.nombre }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field *ngIf="form.get('clasificadorPartida').value && subpartidasOf().length" appearance="outline" class="w-100">
                <mat-label>Subpartida</mat-label>
                <mat-select formControlName="clasificadorSubpartida" (selectionChange)="onSubpartidaChange()">
                  <mat-option [value]="null">Sin subpartida</mat-option>
                  <mat-option *ngFor="let sub of subpartidasOf()" [value]="sub.nombre">{{ sub.nombre }}</mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field *ngIf="form.get('clasificadorSubpartida').value && familiasOf().length" appearance="outline" class="w-100">
                <mat-label>Familia</mat-label>
                <mat-select formControlName="clasificadorFamilia">
                  <mat-option [value]="null">Sin familia</mat-option>
                  <mat-option *ngFor="let familia of familiasOf()" [value]="familia">{{ familia }}</mat-option>
                </mat-select>
              </mat-form-field>

              <app-autocomplete *ngIf="form.get('project').value" [control]="form.get('grant')" [config]="{
                  label: 'Financiación', placeholder: 'Seleccionar financiación...', options: grantOptions }">
              </app-autocomplete>
            </ng-container>
          </section>
        </div>

        <aside class="iaf-side">
          <section class="iaf-section">
            <span class="cf-dlg-section__label">Documento adjunto</span>

            <div class="iaf-file-actions">
              <input #fileInput class="iaf-file-input" type="file" accept=".pdf,.png,.jpg,.jpeg" (change)="onFileSelected($event)">
              <button mat-stroked-button type="button" class="cf-btn" (click)="fileInput.click()" [disabled]="loadingFile">
                <mat-icon>file_upload</mat-icon> Subir archivo
              </button>
              <button mat-stroked-button type="button" class="cf-btn" (click)="pickFromFiles()" [disabled]="loadingFile">
                <mat-icon>folder</mat-icon> Desde Ficheros
              </button>
              <button *ngIf="hasFile" mat-stroked-button type="button" class="cf-btn iaf-btn--danger" (click)="removeFile()" [disabled]="loadingFile">
                <mat-icon>delete</mat-icon> Quitar
              </button>
            </div>

            <app-loading-state *ngIf="loadingFile" [compact]="true" message="Cargando documento…"></app-loading-state>

            <ng-container *ngIf="!loadingFile">
              <div class="iaf-file-preview" *ngIf="hasFile && (imageUrl || pdfUrl); else noFile">
                <img *ngIf="isImage && imageUrl" [src]="imageUrl" alt="Documento de la inversión">
                <iframe *ngIf="isPdf && pdfUrl" [src]="pdfUrl" title="Documento de la inversión"></iframe>
              </div>
              <ng-template #noFile>
                <div class="iaf-file-empty">
                  <mat-icon>attach_file</mat-icon>
                  <span>Adjunta la factura de compra (PDF, PNG o JPG).</span>
                </div>
              </ng-template>
            </ng-container>
          </section>
        </aside>
      </div>

      <div class="iaf-alert iaf-alert--error iaf-save-error" *ngIf="saveError">
        <mat-icon>error</mat-icon>
        <span>{{ saveError }}</span>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="loadingFile">
        <mat-icon>save</mat-icon> {{ isEdit ? 'Guardar cambios' : 'Crear inversión' }}
      </button>
    </div>
  </ng-container>
</div>
